import { Button, Modal } from "react-bootstrap";
import { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import { Formik, Form } from "formik";
import { CODE, DEFAULT_PAGE_INDEX, KEY, MAX_PAGE_SIZE, NAME_BUTTON_FLOW, SELECTION_MODE, TYPE_TU_TRUC, TYPE_WH, WF_TRACKER } from "../../utils/Constant";
import { toast } from "react-toastify";
import '../TongHopphieu.scss';
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import { RESPONSE_CODE_SUCCESS } from "../../category-personnel/const/PersonnelConst";
import ModelHeader from "../../component/ModelHeader";
import { getDsVatTuPhieu, } from "../../phan-he-tu-truc/services/TuTrucServices";
import { HoanTraColumnsTableCustom } from "../constants/TongHopPhieuColumns";
import { AnyAaaaRecord } from "node:dns";
import * as Yup from "yup";
import { createPhieuHoanTra, updateStatusHoanTra } from "../services/TongHopPhieuServices";
import { formatDateAdvanceToString } from "../../utils/FormatUtils";
import TextField from "../../component/TextField";


interface Props {
  show: boolean;
  typeTuTruc?: any;
  onHide: () => void;
  initialValues: any;
  dataRow?: any;
}

interface InventoryItem {
  iventory: number;
  code: string;
  unitofMeasure: string;
  materialGroup: number;
  materialType: string;
  name: string;
  peShipment: number;
  id: number;
  unitofMeasureName: string;
}

const DialogSuaPhieuHoanTra = (props: Props) => {
  const { show, onHide, typeTuTruc, initialValues, dataRow } = props;
  const { setIsLoading } = useContext(AppContext);

  const [isChangeRowData, setIsChangeRowData] = useState<boolean>(false);
  const [lstItem, setLstItem] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const formRef = useRef<any>()

  const caculatorTotalAmount = (values: any) => Number(values?.totalQuantity) * (Number(values?.sellingPrice) + ((Number(values?.vat || 0) / 100) * Number(values?.sellingPrice)))

  const getSelectedRowsData = async (id: string) => {
    try {
      setIsLoading(true);
      const { data } = await getDsVatTuPhieu({ pageSize: MAX_PAGE_SIZE, pageIndex: DEFAULT_PAGE_INDEX, slipId: id, type: 16 });
      if (CODE.SUCCESS === data.code) {
        setLstItem([...data.data.content].map(values => ({ ...values.item, ...values, id: values.id, unitOfMeasureName: values.item.unitofMeasureName })));
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại');
      };
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initialValues?.id && getSelectedRowsData(initialValues?.id);
  }, [initialValues?.id]);
  // useEffect(() => {
  //   setLstItem(initialValues?.subs)
  // }, [initialValues])


  const handleSubmit = async (values: AnyAaaaRecord) => {
    handlerSubmitBSCoSoTuTruc(values) // Lĩnh về tủ trực
  };





  const generateSlipDto = (values: any) =>
  ({
    ...values,
    code: null,
    content: data?.content || values?.content,
    id: null,
    sellingPrice: Number(values?.sellingPrice) || 0,
    totalQuantity: Number(values?.totalQuantity) || 0,
    requireQuantity: Number(values?.totalQuantity) || 0,
    // totalAmount: caculatorTotalAmount(values),
    vat: Number(values?.vat) || 0,
    whReceiveName: values?.whReceive?.whReceiveName || values?.whReceiveName,
    whReceive: values?.whReceive?.whReceiveCode || values?.whReceive,
    whReceiveId: values?.whReceive?.id || values?.whReceiveId,
    type: 16,
    subs: null,
    warehouseExportType: 'HTTDT',
  })

  const handlerSubmitBSCoSoTuTruc = async (values: any) => {
    if (!data?.content) return toast.warning("Vui lòng nhập lý do");
    const firstInvalidItem = lstItem.find(
      (item: any) => item.totalQuantity > item?.requireQuantity);
    const errorMessage = firstInvalidItem
      ? `SL duyệt "${firstInvalidItem.name}" không hợp lệ!` : !lstItem.length ? "Chưa có thuốc/VT" : null;
    if (errorMessage) return toast.warning(errorMessage)
    try {
      setIsLoading(true)
      let slipDto = { ...generateSlipDto(values) };
      delete slipDto.tempItem;
      const data = {
        listMaterialBudget: [values?.id],
        slipDto,
        lstItem: lstItem.map((item: any) => {
          const _item = {
            ...item?.tempItem,
            ...item,
            iventory: Number(item?.tempItem?.iventory || item?.iventory),
            totalAmount: caculatorTotalAmount(item),
          };
          delete _item.id
          delete _item.tempItem
          return _item;
        })
      };
      let res =
        await createPhieuHoanTra(data);
      if (res?.data?.code === RESPONSE_CODE_SUCCESS) {
        toast.success("Thành công");
        handlerSubmitStatus()
        setIsChangeRowData(false);
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handlerSubmitStatus = async () => {
    try {
      setIsLoading(true)
      let res =
        await updateStatusHoanTra(initialValues?.id);
      if (res?.data?.code === RESPONSE_CODE_SUCCESS) {
        toast.success("Thành công");
        onHide();
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChangeRowInput = (index: number, value: any, name: string) => {
    const newLstItem = [...lstItem];
    newLstItem[index] = {
      ...newLstItem[index],
      [name]: value,
    };
    setLstItem(newLstItem);
  };

  const approveQuantityInput = (dataColumn: any) => {
    const {
      setIsChangeRowData = () => { },
      handleChangeRowInput = () => { },
      status,
      data,
      row,
    } = dataColumn;

    return (
      <input
        className="min-w-80 w-100 border-custom-input text-end"
        type="number"
        defaultValue={data[row.index]?.totalQuantity}
        onInput={(e: any) => setIsChangeRowData(true)}
        onBlur={(e: any) => handleChangeRowInput(row.index, e.target.value, "totalQuantity")}
      />
    )
  };

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={Yup.object({})}
        onSubmit={handleSubmit}
      >
        {({ values, touched, errors, handleChange, handleSubmit, setFieldValue }) => {
          return <Form ref={formRef} onSubmit={handleSubmit}>
            <ModelHeader onHide={onHide} title={`Phiếu hoàn trả`} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces w-100 justify-content-center p-15">
                <div className="flex flex-wrap mt-10">
                  <div className="flex spaces w-50">
                    <span className="text-ellipsis-title fw-bold min-w-100px">
                      Tên bệnh nhân:
                    </span>
                    <span className="text-ellipsis-content">
                      {initialValues?.patientName || "..."}
                    </span>
                  </div>
                  <div className="flex spaces w-50">
                    <span className="text-ellipsis-title fw-bold min-w-100px">
                      Giới tính:
                    </span>
                    <span className="text-ellipsis-content">
                      {initialValues?.patientGenderName || "..."}
                    </span>
                  </div>
                  <div className="flex spaces w-50">
                    <span className="text-ellipsis-title fw-bold min-w-100px">
                      Loại bệnh nhân:
                    </span>
                    <span className="text-ellipsis-content">
                      {initialValues?.patientRequestType || "..."}
                    </span>
                  </div>
                  <div className="flex spaces w-50">
                    <span className="text-ellipsis-title fw-bold min-w-100px">
                      Ngày y lệnh:
                    </span>
                    <span className="text-ellipsis-content">
                      {initialValues?.doCreation ? formatDateAdvanceToString(initialValues?.doCreation) : "..."}
                    </span>
                  </div>
                  <div className="flex spaces w-50">
                    <span className="text-ellipsis-title fw-bold min-w-100px">
                      Tên kho:
                    </span>
                    <span className="text-ellipsis-content">
                      {initialValues?.mateWhName || "..."}
                    </span>
                  </div>
                  <div className="flex spaces w-50">
                    <TextField
                      label="Lý do:"
                      name="content"
                      className="flex w-100"
                      value={initialValues?.content || data?.content}
                      labelClassName="spaces mt-5 mr-5 min-w-100px"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                </div>
              </div>
              <div className=" spaces bg-white mb-0">
                <TableCustom<any>
                  className="spaces table-ds-thuoc"
                  data={lstItem}
                  columns={HoanTraColumnsTableCustom(
                    approveQuantityInput,
                    {
                      handleChangeRowInput,
                      setIsChangeRowData,
                      title: 'Hoàn Trả',
                      className: 'text-center text-white align-middle bg-pri min-w-80px max-w-100',
                      id: 'totalquantity',
                      index: 5,
                    }
                  )
                  }
                  verticalScroll={true}
                  selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                />
              </div>
            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6">

              <Button type="submit" className="btn btn-fill min-w-90px spaces ms-1">
                Lưu
              </Button>
            </div>
          </Form>
        }}
      </Formik>

    </Modal>
  );
};

export default DialogSuaPhieuHoanTra;
